import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import { store } from '../../../store/store';
import NotificationsSetupButton from './NotificationsSetupButton';
import AclContextProvider from '../../Acl/Components/AclContextProvider';

loadDOMComponent({
	selector: 'react-notifications-setup-button',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<NotificationsSetupButton />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
